// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"28544ffb","154":"6620705b","268":"3ae0b1b1","502":"dc8b4b80"}[chunkId] + ".chunk.js";
};